// Synthetic demo payload for the /developers docs page and the public /api/demo/lane endpoint.
//
// HONESTY: this is a hand-authored, representative sample, NOT a live quote and NOT any real
// customer's data. The envelope carries `_demo: true` and a plain-language `note`. It is served by
// worker.js so the curl on the docs page returns a real 200 with rich data (never an error), and the
// same object is rendered statically on the page so the first impression is always perfect.
//
// SHAPE: `data` mirrors EXACTLY what the real API returns from `GET /lane?pol=..&pod=..` — the
// `freight_rate_lane_latest` view row wrapped in a `{ data }` envelope (see
// supabase/functions/frm-api/index.ts and packages/db/migrations). The real API returns just `{ data }`
// with no `_demo`/`note`; those two keys are the demo's honesty markers and are the only difference.

/** The public demo key. Mirrors the family convention (tmcp_demo_public / lmcp_demo_public). */
export const DEMO_KEY = 'frm_demo_public'

/** Logical path of the always-200 demo endpoint served by worker.js (mirrors the real `/lane`). */
export const DEMO_PATH = '/api/demo/lane'

/** Absolute endpoint used in the copyable curl. */
export const DEMO_ENDPOINT = `https://freightratesmcp.com${DEMO_PATH}`

/** The flagship demo lane, prefilled: Shanghai to Rotterdam. Real param names: pol / pod (UN/LOCODE). */
export const DEMO_QUERY = 'pol=CNSHA&pod=NLRTM'

/** A real, runnable curl. The demo endpoint ignores the key and always returns the rich sample. */
export const DEMO_CURL = `curl -s '${DEMO_ENDPOINT}?${DEMO_QUERY}' \\
  -H 'Authorization: Bearer ${DEMO_KEY}'`

/**
 * The demo response. `data` is a faithful `freight_rate_lane_latest` row; the envelope adds `_demo`
 * and `note`. Keep the key order stable: it is what renders in the docs code block.
 * @type {import('./demoRate.d.mts').DemoRate}
 */
export const DEMO_RATE = {
  _demo: true,
  note: 'Synthetic sample for shape and shading, not a live quote or any real shipment. The live API returns the same {data} row without these two demo keys. Browse live rates free at freightratesmcp.com.',
  data: {
    pol_code: 'CNSHA',
    pol_name: 'Shanghai',
    pol_country: 'CN',
    pol_terminal: null,
    pod_code: 'NLRTM',
    pod_name: 'Rotterdam',
    pod_country: 'NL',
    pod_terminal: null,
    carrier: 'MAERSK',
    vessel: 'MAERSK EDMONTON',
    voyage: '532W',
    route_code: 'AE7',
    service_mode: 'direct',
    is_via: false,
    transit_days: 32,
    etd: '2026-07-24',
    eta: '2026-08-25',
    price_20gp: 1290,
    price_40gp: 2075,
    price_40hc: 2140,
    currency: 'USD',
    line_category: 'Asia to Europe & Mediterranean',
    line_category_id: 'asia-europe-med',
    source_updated_at: '2026-07-20T06:00:00Z',
    last_seen_at: '2026-07-20T06:12:00Z',
    carrier_logo: null,
    source: 'freightower',
  },
}
